import { render, staticRenderFns } from "./EcommerceOrderChart.vue?vue&type=template&id=c183b0b8"
import script from "./EcommerceOrderChart.vue?vue&type=script&lang=js"
export * from "./EcommerceOrderChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports